import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from '../http.service';
import { PendingSubscription } from '../interfaces/subscription.interface';

@Injectable({
  providedIn: 'root'
})
export class PendingSubscriptionsService {

  constructor(
    private http: HttpService
  ) { }

  getPendingSubscriptions() {
    return this.http.get<PendingSubscription[]>(environment.api.routes.subscription.paid.pending);
  }

  hasPendingInvoices(subscriptionId : string) {
    return this.http.get<any>(environment.api.routes.subscription.paid.pending_invoice,{"subscriptionId": subscriptionId});
  }
}
